// @flow

// Types
import type {
  Asset,
  AssetsById,
} from 'fc-model-assets/types'

// Constants
import {
  PROP_ASSET_ID,
  PROP_PARENT,
  PROP_CATEGORY,
  PROP_SHAPE,
} from 'fc-model-assets'

// Libs
import _reduce from 'lodash/reduce'
import _uniq from 'lodash/uniq'

// Local Types
type Index = { [number]: Array<number> }

// Exports
export default function buildChildrenIndex (assets: AssetsById): Index {
  return _reduce(assets, (acc: Index, {
    [PROP_ASSET_ID]: id,
    [PROP_PARENT]: parent,
    [PROP_CATEGORY]: category,
    [PROP_SHAPE]: shape,
    }: Asset): Index => {
    const children = acc[parent] || []

    // Ensure rootAsset id 1 is not set as child of itself
    if (id === 1) {
      return acc
    }

    acc[parent] = _uniq([
      ...children,
      id,
    ])

    return acc
  }, {})
}
